import 'react-image-crop/dist/ReactCrop.css';
import ReactCrop, { Crop } from 'react-image-crop';
import { StateSetter } from 'types/utils/React';

export type ImageCrop = Crop;

export type ImageCropperProps = {
  crop: Crop;
  src: string;
  setCrop: StateSetter<Crop>;
};

const ImageCropper = ({ crop, src, setCrop }: ImageCropperProps): JSX.Element => (
  <ReactCrop
    imageStyle={{ maxHeight: 400, maxWidth: 712 }}
    src={src}
    crop={crop}
    onChange={setCrop}
  />
);

export default ImageCropper;
